const protocol = require('@/api/protocol.js')

/**
 * audience 123
 *
 */
const user = {}

/**
 * getAudienceList()
 * Promise that returns a list of audiences
 *
 * @param {object} e - An object of config options
 * @param {integer} e.offset - Offset - Default value : 0
 * @param {integer} e.limit - Limit
 * @param {boolean} e.count - count - Default value : false
 * @param {string} e.orderby - Orderby - fieldname,[asc|desc]+
 * @param {boolean} e.with_area - with_area - Default value : false
 * @return {promise} - List of audience
 */
user.getAudienceList = (e) => {
  return new Promise((resolve, reject) => {
    const path = '/api/auth/login'
    const method = 'get'
    const data = {}
    if (typeof e === 'object') {
      for (const [key, value] of Object.entries(e)) {
        data[key] = value
      }
    }
    protocol
      .call(path, method, data)
      .then(res => {
        return resolve(res)
      })
      .catch(err => {
        return reject(err)
      })
  })
}

// //
// /**
//  * getAudienceId()
//  * Promise that returns a particular audience
//  * @param {integer} e.audience_id - id of an audience (required)
//  * @return {object} - Particular audience
//  */
// audience.getAudienceId = (e) => {
//   return new Promise((resolve, reject) => {
//     const _audience_id = e.audience_id ? e.audience_id : 0
//     const path = "/api/audience/" + _audience_id
//     const method = "get"
//     const data = { }
//     protocol
//     .call(path, method, data)
//     .then(res => {
//       return resolve(res)
//     })
//     .catch(err => {
//       return reject(err)
//     })
//   })
// }
//
// // Method that updates an audience
// audience.putAudienceId = (e) => {
//   return new Promise((resolve, reject) => {
//     const _audience_id = e.audience_id ? e.audience_id : 0
//     const path = "/api/audience/" + _audience_id
//     const method = "put"
//     let data = { }
//
//     e.forEach(function callback(value, index) {
//       if(index !== 'audience_id')
//         data[index] = value
//     })
//
//     protocol
//     .call(path, method, data)
//     .then(res => {
//       return resolve(res)
//     })
//     .catch(err => {
//       return reject(err)
//     })
//   })
// }
//
// // Method that returns a list of demographic audiences
// audience.getAudienceDemographicList = (e) => {
//   return new Promise((resolve, reject) => {
//     const path = "/api/audience/demographic/list"
//     const method = "get"
//     let data = { }
//
//     e.forEach(function callback(value, index) {
//       data[index] = value
//     })
//
//     protocol
//     .call(path, method, data)
//     .then(res => {
//       return resolve(res)
//     })
//     .catch(err => {
//       return reject(err)
//     })
//   })
// }
//
// /**
//  * getAudienceDemographicList()
//  * Promise that returns a list of demographic audiences
//  * getAudienceDemographicList
//  * @param {integer} e.audience_id - id of an audience (required)
//  * @return {object} - List of current areas for an audience
//  */
// audience.getAudienceDemographicList = (e) => {
//   return new Promise((resolve, reject) => {
//     const _audience_id = e.audience_id ? e.audience_id : 0
//     const path = "/api/audience/" + _audience_id + "/area/list"
//     const method = "get"
//     const data = { }
//
//     protocol
//     .call(path, method, data)
//     .then(res => {
//       return resolve(res)
//     })
//     .catch(err => {
//       return reject(err)
//     })
//   })
// }
// // Method that returns current pixels for an audience
// // required: e.audience_id
// audience.getAudiencePixelList = (e) => {
//   return new Promise((resolve, reject) => {
//     const _audience_id = e.audience_id ? e.audience_id : 0
//     const path = "/api/audience/" + _audience_id + "/pixel/list"
//     const method = "get"
//     const data = { }
//
//     protocol
//     .call(path, method, data)
//     .then(res => {
//       return resolve(res)
//     })
//     .catch(err => {
//       return reject(err)
//     })
//   })
// }

module.exports = user
